<div class="splash" ng-cloak="" *ngIf="splashScreen" i18n="Dashboard Splash Screen div">
  <!-- <div style="float: right">
      <mat-icon (click)="close()" style="color: #777; margin: 5px;">close_outline</mat-icon>
  </div> -->

  <div class="panel-body splash-text" *ngIf="!isChineseSystem()">
    <div>
      <h3 style="text-align: center;"> Announcement: Security Update Feature </h3> <br />

      <b>Dear The BHive-Factory User, </b> <br />
      <br /><br />

      We are continuously improving our security to ensure that your data is kept safely.<br /><br />

      As part of our ongoing efforts to increase security, we would like you to confirm if this email is
      valid:<br /><br />

      <form [formGroup]="forms">
        <mat-form-field class="question">
          <mat-label>{{ "USER_SIGNUP_COMPONENT.PERSONAL_INFO.EMAIL.LABEL" | translate }}</mat-label>
          <input matInput placeholder="{{ 'USER_SIGNUP_COMPONENT.PERSONAL_INFO.EMAIL.LABEL' | translate }}"
            formControlName="emailControl" (blur)="validateEmail()" required>
          <mat-error *ngIf="this.forms.get('emailControl').invalid">{{getErrorMessage()}}</mat-error>
          <mat-error *ngIf="this.forms.get('emailControl').errors?.emailTaken">Email is already associated with another
            account.</mat-error>
        </mat-form-field>
      </form>

      <br />

      All future communications, including password reset instructions, will be coursed through this email address.
      <br /><br />

      You can always change your email in the profile section if there are future changes in this regard<br /><br />

      If you have any questions, please do not hesitate to contact us via members@thebhive.net. <br /><br />

      <b> Thanks for your understanding and warm regards, <br />
        Your The BHive® Team </b>

      <br /> <br />
      <div style="text-align: center;">
        <button mat-raised-button [disabled]="this.forms.get('emailControl').invalid"
          (click)="saveUserAcceptance()">Understand</button>
      </div>
    </div>
  </div>

  <!-- <div style="text-align: center; height: 50px">
    <button class="btn btn-default close-button" (click)="close()">Close</button>
  </div> -->

</div>



<!-- <h3 i18n="Dashboard Heading | The title of the dashboard page.">
  <img *ngIf="globalsService.profile['brandLogoUrl'] != ''" [src]="'/assets/' + globalsService.profile['name'] + '/' + globalsService.profile['brandLogoUrl']" style="width:100px; float: right; margin-top: -30px;">
</h3> -->
<br />


<div class="row" style="width: 100%;">

  <!-- <div class="panel panel-default" style="height: 1150px;" *ngIf="!isAdmin">
    <p align="center">
      <iframe [src]="sanitizedURL" frameborder="0" width="98%" height="1100px" right="30px" allowtransparency></iframe>
    </p>

    <br />
    <br />
  </div> -->
  <app-dashboard-factory *ngIf="isMill"></app-dashboard-factory>
  <app-dashboard-brand *ngIf="isBrand || isImporter"></app-dashboard-brand>
  <br />
  <br />

  <div class="flex flex-col flex-auto min-w-0">

    <!-- Main -->
    <div class="flex-auto p-6 sm:p-10">

      <!-- CONTENT GOES HERE -->

      <div>

        <div class="content" style="display: flex;">

            <!--

          <div class="col-md-6" *ngIf="isChineseSystem()">
            <div class="panel panel-default" style="height: 400px;">
              <div class="panel-heading"
                i18n="BHive Information div | The field on the dashboard containing information about the BHive system.">
                {{"HOME_COMPONENT.BHIVE_INFO_BOX_HEADER" | translate}}</div>
              <div class="panel-body" style="height:338px;overflow-y:scroll;">

                <div *ngIf="!isBrand && !isImporter">
                  Dear The BHive-Factory Members, <br />
                  亲爱的BHive工厂会员：<br />
                  <br />
                  In this section we will inform you about <b><u>What is New</u></b> in The BHive:<br />
                  本篇为您介绍有关BHive的新增功能：<br />
                  <br />
                  <b>1. Enter your HIGG and Supplier ID</b><br />
                  <b>1.输入您的HIGG ID和供应商ID</b><br />
                  <br />
                  You can now include your HIGG ID as well as individual supplier IDs for different customers to your
                  profile. <br />
                  现在，您可以在个人资料中输入您的HIGG ID以及针对不同客户的供应商ID。<br />
                  Both can be found in your profile settings (<mat-icon
                    style="color: #777; display: inline-flex; vertical-align: middle;">settings</mat-icon>). <br />
                  此二项功能可以在您个人资料的设置（<mat-icon style="color: #777; display: inline-flex; vertical-align: middle;">settings
                  </mat-icon>）中找到。<br />
                  <br />
                  Enter your individual supplier ID for each of your customers in the list of connected brands.
                  你可以在关联的品牌列表中输入对应这个客户的供应商ID。<br />
                  <br />
                  Your HIGG ID can be entered below. <br />
                  然后，您的HIGG ID可以在下面输入。<br />
                  <br />
                  <b>2. Confirm completeness of your monthly inventories.</b> <br />
                  <b>2.确认您每月库存的完整性。</b><br />
                  How does this work? <br />
                  操作作方法：<br />
                  Once you have scanned all chemical products used in one month, you can open the month’s summary and
                  set the button under “confirm completeness” to complete. <br />
                  当您扫描一个月内使用的所有化学产品后，您可以打开该月的小计，点击“确认完整性”按钮，表示设置为完成。<br />
                  <br />
                  Your connected brands and partners will then be able to see a green button as an indicator for
                  completeness of the month. <br />
                  然后，您所关联的品牌和合作伙伴将能够看到这个作为月度完整性指标的绿色图标。<br />
                  <br />
                  <b>3. Changes in the navigation:</b> <br />
                  <b>3.导航栏的更改：</b><br />
                  <br />
                  All tools and features of The BHive are now found in a compromised navigation header, which you can
                  find above in the upper left corner. <br />
                  The BHive的所有工具和功能现在都位于合并于左上角的导航标识中。<br />
                  Simply click on the navigation symbol (<mat-icon
                    style="color: #777; display: inline-flex; vertical-align: middle;">menu</mat-icon>) to view all
                  tools and features. <br />
                  点击导航符号（<mat-icon style="color: #777; display: inline-flex; vertical-align: middle;">menu</mat-icon>
                  ）即可查看所有工具和功能。<br />
                  <br />
                  In our new section “Analytics” you will soon find reporting tools, with which you can track your
                  chemical performance. <br />
                  在我们新的部分 “分析”中，您将很快找到用来跟踪化学性能的报告工具。<br />
                  <br />
                  The BHive’s frontpage (former Dashboard) will now be found behind the new Home Button (<mat-icon
                    style="color: #777; display: inline-flex; vertical-align: middle;">home</mat-icon>).<br />
                  现在，您点击 “主页”按钮（<mat-icon style="color: #777; display: inline-flex; vertical-align: middle;">home
                  </mat-icon>）可以找到BHive的主页（即以前的信息中心）。<br />
                  <br />
                  If you have any questions, feel free to contact our team via <a
                    href="mailto:members@thebhive.net">members@thebhive.net</a>. <br />
                  如有任何疑问，请随时通过<a href="mailto:members@thebhive.net">members@thebhive.net</a>与我们的团队联系。<br />
                  <br />
                  Warm regards, <br />
                  致<br />
                  Your The BHive-Team<br />
                  The BHive团队全体成员
                </div>
                <div *ngIf="isBrand || isImporter">
                  Dear The BHive Brand Members <br />
                  亲爱的BHive品牌成员 <br />
                  <br />
                  In this section we will inform you about <b><u>What is New</u></b> in The BHive: <br />
                  本篇向您介绍有关BHive的新增功能：<br />
                  <br />
                  <b>1. See your facilities’ HIGG IDs and Supplier IDs</b> <br />
                  <b>1.查看您工厂的HIGG ID和供应商ID</b> <br />
                  Your connected facilities now have the option to fill in the supplier ID specified to your brand, as
                  well as their HIGG ID in the settings. <br />
                  现在，您所连接的工厂可以在设置中选择填写贵品牌指定的供应商ID，以及他们的HIGG ID。<br />
                  Where to find the IDs? <br />
                  如何找到这些ID？<br />
                  <ul>
                    <li>Both supplier and HIGG ID can be found under “Wet Processing Units” in the Menu Bar. Please
                      select the facility whose profile you would like to view. </li>
                    <li>供应商ID和HIGG ID均可在菜单栏中的“湿处理单位”下找到。 您可选择要查看其资料的工厂。</li>
                    <li>Additionally, the supplier ID will be shown under “Supplier Inventories” when selecting said
                      factory, under the factories Name </li>
                    <li>选好该工厂，供应商ID将显示在“供应商库存清单”中工厂名称下方</li>
                  </ul>
                  Please note: factory must have entered the ID in order for you to see them. <br />
                  注：仅工厂必须输入了ID您才能看到。<br />
                  <br />
                  <br />
                  <b>2. Monthly completeness confirmation</b><br />
                  <b>2.每月完整性确认</b><br />
                  <br />
                  Your connected facilities now have the option to mark a month’s inventory as complete. <br />
                  您关联的工厂现在可以对一个月的库存选择标记“已完成”。<br />
                  <br />
                  When selecting country, facility, year and period under “Supplier Inventories”, you can now see
                  whether a month is marked as complete or incomplete. <br />
                  在“供应商清单”下选择国家/地区，工厂，年份和时段，您现在可以看到此月被标记为已完成或未完成。<br />
                  <br />
                  Please note: In order to see a month’s completeness, you have to select a certain month (quarterly and
                  annual summaries are not included.) <br />
                  请注意：为了查看月份的完整性，您必须选择一个月份（季度和年度合计不纳入。）<br />
                  <br />
                  <b>3. The BHive compliance reporting.</b> <br />
                  <b>3.BHive合规性报告。</b><br />
                  <br />
                  You will find the tool in the updated navigation above (<mat-icon
                    style="color: #777; display: inline-flex; vertical-align: middle;">menu</mat-icon>) in the new
                  section “Analytics”. <br />
                  您可以在更新的导航新导航工具（<mat-icon style="color: #777; display: inline-flex; vertical-align: middle;">menu
                  </mat-icon>）中找到“ Analytics”。<br />
                  <br />
                  The new tool allows a customized filtering of your factories’ compliance performance either based on
                  country or transnationally. <br />
                  用此新工具您可以自定义针对工厂的国内或国际合规情况进行筛查。<br />
                  You are also able to select a time frame, as well as the compliance criteria that acts as base for the
                  performance evaluation. <br />
                  您还可以选择时间范围以及作为绩效评估基础的合规性标准。<br />
                  <br />
                  With this, you are now able to compare your different factories’ performance throughout the globe.
                  <br />
                  通过此项，您现在可以比较您全球不同工厂的状况/性能。<br />
                  <br />
                  Our team will further expand Analytics in the next few months, e.g. by adding a comparison option
                  including different time frames, with which you will be able to track performance development. <br />
                  我们的团队将在接下来的几个月扩展此“Analytics”工具，比如， 通过添加一个包括不同时间范围的比较选项，让您将可以跟踪性能发展。<br />
                  <br />
                  <b>4. Filter by Customer option for brands: </b><br />
                  <b>4.给品牌的按客户筛选：</b><br />
                  When visiting the factories’ inventories, you are now able to filter the chemical product list for
                  chemicals that were marked as used for {{myName}} by the factory user. <br />
                  访问工厂库存时，您现在可以过筛选工厂标记成{{myName}}使用的化学品的产品清单<br />
                  <br />
                  Please note that you will only see the products that were <u>actively marked</u> as used for
                  {{myName}} by the factory. <br />
                  注：您只能看到工厂主动标记为{{myName}}使用的产品。<br />
                  <br />
                  For more information feel free to contact us via <a
                    href="mailto:members@thebhive.net">members@thebhive.net</a>. <br />
                  更多信息，请随时通过<a href="mailto:members@thebhive.net">members@thebhive.net</a>与我们联系。<br />
                  <br />
                  Warm regards, <br />
                  致 <br />
                  Your The BHive-Team <br />
                  The BHive团队全体成员
                </div>


              </div>
            </div>

          </div>

        -->

          <!--

          <div class="col-md-6" *ngIf="!isChineseSystem()">

            <div class="panel panel-default" style="height: 400px;">

              <div class="panel-heading" i18n="BHive Information div | The field on the dashboard containing information about the BHive system.">

                {{"HOME_COMPONENT.BHIVE_INFO_BOX_HEADER" | translate}}

            </div>

              <div class="panel-body" style="height:338px;overflow-y:scroll;">


          <div *ngIf="!isBrand && !isImporter" class=""><blockquote class="" style="margin: 0px 0px 0px 40px; border: none; padding: 0px;">

            <div class="">

            <div class=""><u class=""><b class="">PLATFORM UPDATE - 20TH OF JUNE</b></u>
            </div>
          </div>

        <div class="">

            <div class=""><br class=""></div>
        </div>

        <div class="">

            <div class="">Dear The BHive User,

        </div>
       </div>
        <div class="">
            <div class="">
            <br class="" style="caret-color: rgb(34, 34, 34); color: rgb(34, 34, 34); text-align: justify;"></div>
        </div><div class=""><div class=""><span class="" style="caret-color: rgb(34, 34, 34); color: rgb(34, 34, 34); text-align: justify; font-family: arial, helvetica neue, helvetica, sans-serif;">
            <font color="#222222"
            class="">B</font><font color="#000000" class="">ased the experiences shared with us by our users,&nbsp;</font></span><font color="#222222" face="arial, helvetica neue, helvetica, sans-serif" class="" style="caret-color: rgb(34, 34, 34); color: rgb(34, 34, 34); text-align: justify;">we have been&nbsp;working on a<b class="">&nbsp;platform update for The BHive</b></font><span class="" style="text-align: justify;"><span class="" style="font-family: arial, helvetica neue, helvetica, sans-serif;"><b class="">®, which&nbsp;</b></span></span><font color="#222222" face="arial, helvetica neue, helvetica, sans-serif" class="" style="caret-color: rgb(34, 34, 34); color: rgb(34, 34, 34); text-align: justify;">
                <strong class="">will go live on June 20th.&nbsp;</strong>We hope that our new functionalities will make working with The BHive</font>
                <span class="" style="text-align: justify;"><span class="" style="font-family: arial, helvetica neue, helvetica, sans-serif;">®</span></span><font color="#222222" face="arial, helvetica neue, helvetica, sans-serif" class="" style="caret-color: rgb(34, 34, 34); color: rgb(34, 34, 34); text-align: justify;">&nbsp;even more efficient.</font></div></div><div class=""><div class=""><font color="#222222" face="arial, helvetica neue, helvetica, sans-serif" class="" style="caret-color: rgb(34, 34, 34); color: rgb(34, 34, 34); text-align: justify;"><br class=""></font></div></div><div class=""><div class=""><font color="#222222" face="arial, helvetica neue, helvetica, sans-serif" class="" style="caret-color: rgb(34, 34, 34); color: rgb(34, 34, 34); text-align: justify;">To help you navigate the new features, we would like to invite all The BHive</font><span class="" style="text-align: justify;"><span class="" style="font-family: arial, helvetica neue, helvetica, sans-serif;">®</span></span><font color="#222222" face="arial, helvetica neue, helvetica, sans-serif" class="" style="caret-color: rgb(34, 34, 34); color: rgb(34, 34, 34); text-align: justify;">&nbsp;users to join one of our&nbsp;<b class="">technical webinars</b>, during which we will introduce all new features and answer your questions. If you are interested, please register to one of the sessions below:</font></div></div><div class=""><div class=""><font color="#222222" face="arial, helvetica neue, helvetica, sans-serif" class="" style="caret-color: rgb(34, 34, 34); color: rgb(34, 34, 34); text-align: justify;"><br class=""></font></div></div><div class=""><div class=""><div class=""><div class=""><span class="" style="font-family: arial, helvetica neue, helvetica, sans-serif;"><strong class="">English</strong></span></div></div></div></div><div class=""><div class=""><div class=""><div class=""><span class="" style="font-family: arial, helvetica neue, helvetica, sans-serif;">EN&nbsp;24.06., 9:30 AM (CET): Register&nbsp;<a rel="noopener" href="https://thebhive.us20.list-manage.com/track/click?u=10545bb796625d610f70259ba&amp;id=72c6b89040&amp;e=d9ad330262" target="_blank" class="" style="color: rgb(0, 124, 137);"><span class="" style="color: rgb(0, 0, 0);">here</span></a></span></div></div></div></div><div class=""><div class=""><div class=""><div class="" style="text-align: center;"><div class="" style="text-align: left;"><span class="" style="font-family: arial, helvetica neue, helvetica, sans-serif;">EN 27.06., 12:30 PM (CET): Register</span><span class="" style="font-family: arial, helvetica neue, helvetica, sans-serif;">&nbsp;</span><a rel="noopener" href="https://thebhive.us20.list-manage.com/track/click?u=10545bb796625d610f70259ba&amp;id=5521fb06cc&amp;e=d9ad330262" target="_blank" class="" style="font-family: arial, helvetica neue, helvetica, sans-serif; color: rgb(0, 124, 137);"><span class="" style="color: rgb(0, 0, 0);">h</span></a><a rel="noopener" href="https://thebhive.us20.list-manage.com/track/click?u=10545bb796625d610f70259ba&amp;id=a6be4c4fd7&amp;e=d9ad330262" class="" style="font-family: arial, helvetica neue, helvetica, sans-serif; color: rgb(0, 124, 137);" target="_blank"><span class="" style="color: rgb(0, 0, 0);">ere</span></a></div></div></div></div></div><div class=""><div class=""><div class=""><div class="" style="text-align: center;"><div class=""><div class="" style="text-align: left;"><br class=""></div></div></div></div></div></div><div class=""><div class=""><div class=""><div class="" style="text-align: center;"><div class=""><span class="" style="font-family: arial, helvetica neue, helvetica, sans-serif;"><div class="" style="text-align: left;"><strong class="">Chinese</strong></div></span></div></div></div></div></div><div class=""><div class=""><div class=""><div class="" style="text-align: center;"><div class=""><div class="" style="text-align: left;"><span class="" style="font-family: arial, helvetica neue, helvetica, sans-serif;">CN&nbsp;24.06., 2:00 PM&nbsp;(CST): Register</span><span class="" style="font-family: arial, helvetica neue, helvetica, sans-serif;">&nbsp;</span><a rel="noopener" href="https://thebhive.us20.list-manage.com/track/click?u=10545bb796625d610f70259ba&amp;id=456b40d9d6&amp;e=d9ad330262" target="_blank" class="" style="font-family: arial, helvetica neue, helvetica, sans-serif; color: rgb(0, 124, 137);"><span class="" style="color: rgb(0, 0, 0);">h</span></a><a rel="noopener" href="https://thebhive.us20.list-manage.com/track/click?u=10545bb796625d610f70259ba&amp;id=97aa47c07b&amp;e=d9ad330262" class="" style="font-family: arial, helvetica neue, helvetica, sans-serif; color: rgb(0, 124, 137);" target="_blank"><span class="" style="color: rgb(0, 0, 0);">ere</span></a></div></div></div></div></div></div><div class=""><div class=""><div class=""><div class="" style="text-align: center;"><div class=""><span class="" style="font-family: arial, helvetica neue, helvetica, sans-serif;"><div class="" style="text-align: left;">CN&nbsp; 29.06., 2:00 PM (CST): Register&nbsp;<a rel="noopener" href="https://thebhive.us20.list-manage.com/track/click?u=10545bb796625d610f70259ba&amp;id=cf0f632f2a&amp;e=d9ad330262" target="_blank" class="" style="color: rgb(0, 124, 137);"><span class="" style="color: rgb(0, 0, 0);">here</span></a></div></span></div></div></div></div></div><div class=""><div class=""><div class=""><div class="" style="text-align: center;"><div class=""><div class="" style="text-align: left;">&nbsp;</div></div></div></div></div></div><div class=""><div class=""><div class=""><div class="" style="text-align: center;"><div class="" style="text-align: left;"><span class="" style="font-family: arial, helvetica neue, helvetica, sans-serif;"><strong class="">Turkish</strong></span></div></div></div></div></div><div class=""><div class=""><div class=""><div class="" style="text-align: center;"><div class=""><div class="" style="text-align: left;"><span class="" style="font-family: arial, helvetica neue, helvetica, sans-serif;">TK&nbsp;23.06., 2:00 PM (TRT): Register</span><span class="" style="font-family: arial, helvetica neue, helvetica, sans-serif;">&nbsp;</span><a rel="noopener" href="https://thebhive.us20.list-manage.com/track/click?u=10545bb796625d610f70259ba&amp;id=0eed34b48a&amp;e=d9ad330262" target="_blank" class="" style="font-family: arial, helvetica neue, helvetica, sans-serif; color: rgb(0, 124, 137);"><span class="" style="color: rgb(0, 0, 0);">here</span></a></div></div></div></div></div></div><div class=""><div class=""><div class=""><div class="" style="text-align: center;"><span class="" style="font-family: arial, helvetica neue, helvetica, sans-serif;"><div class="" style="text-align: left;">TK&nbsp;04.07., 2:00 PM (TRT): Register&nbsp;<a rel="noopener" href="https://thebhive.us20.list-manage.com/track/click?u=10545bb796625d610f70259ba&amp;id=5c457c7b6e&amp;e=d9ad330262" target="_blank" class="" style="color: rgb(0, 124, 137);"><span class="" style="color: rgb(0, 0, 0);">here</span></a></div></span></div></div></div></div><div class=""><div class=""><font color="#222222" face="arial, helvetica neue, helvetica, sans-serif" class="" style="caret-color: rgb(34, 34, 34); color: rgb(34, 34, 34); text-align: justify;"><br class=""></font></div></div><div class=""><div class=""><span class="" style="caret-color: rgb(34, 34, 34); color: rgb(34, 34, 34); font-family: arial, helvetica neue, helvetica, sans-serif; background-color: rgb(255, 255, 255);">Also, from June 20th, video tutorials and written instructions will be available in our&nbsp;</span><strong class="" style="caret-color: rgb(34, 34, 34); color: rgb(34, 34, 34); font-family: arial, helvetica neue, helvetica, sans-serif;">
                    Online User Guide</strong><span class="" style="caret-color: rgb(34, 34, 34); color: rgb(34, 34, 34); font-family: arial, helvetica neue, helvetica, sans-serif; background-color: rgb(255, 255, 255);">. Click&nbsp;</span><a rel="noopener" href="https://www.thebhive.net/user-guide-languages" target="_blank" class="" style="color: rgb(0, 124, 137); font-family: arial, helvetica neue, helvetica, sans-serif;">here</a><span class="" style="caret-color: rgb(34, 34, 34); color: rgb(34, 34, 34); font-family: arial, helvetica neue, helvetica, sans-serif; background-color: rgb(255, 255, 255);">, to find the English and Chinese version.&nbsp;</span><span class="" style="caret-color: rgb(34, 34, 34); color: rgb(34, 34, 34); font-family: arial, helvetica neue, helvetica, sans-serif; background-color: rgb(255, 255, 255);">Finally, our&nbsp;</span><strong class="" style="caret-color: rgb(34, 34, 34); color: rgb(34, 34, 34); font-family: arial, helvetica neue, helvetica, sans-serif;">support team&nbsp;</strong><span class="" style="caret-color: rgb(34, 34, 34); color: rgb(34, 34, 34); font-family: arial, helvetica neue, helvetica, sans-serif; background-color: rgb(255, 255, 255);">is always happy to help in case of any additional questions, as well via&nbsp;</span><a rel="noopener" href="mailto:" target="_blank" class="" style="color: rgb(0, 124, 137); font-family: arial, helvetica neue, helvetica, sans-serif;">support@thebhive.net</a><span class="" style="caret-color: rgb(34, 34, 34); color: rgb(34, 34, 34); font-family: arial, helvetica neue, helvetica, sans-serif; background-color: rgb(255, 255, 255);">.</span></div><div class=""><span class="" style="caret-color: rgb(34, 34, 34); color: rgb(34, 34, 34); font-family: arial, helvetica neue, helvetica, sans-serif; background-color: rgb(255, 255, 255);"><br class=""></span></div></div></blockquote></div>


                 <div *ngIf="!isBrand && !isImporter">
                  Dear The BHive-Factory Members, <br />
                  <br />
                  In this section we will inform you about <b><u>What is New</u></b> in The BHive:<br />
                  <br />
                  <h3>Desktop Platform </h3>
                  <h4>1. The BHive Dashboard Statistics</h4>
                  With the new Dashboard feature you can now see important numbers and developments in one view. <br />
                  <br />
                  <h4>2. New Language Features</h4>
                  Users can now use The BHive in three languages:
                  <ul>
                    <li>Chinese</li>
                    <li>English</li>
                    <li>Spanish</li>
                  </ul>
                  <br />
                  <i>Soon to follow: Turkish and Vietnamese</i> <br />
                  <br />
                  <u>How to change your language:</u> <br />
                  Option 1:
                  <ul>
                    <li>Change the language immediately by clicking on the field next to the Settings (upper right
                      corner) </li>
                  </ul>
                  <br />
                  Option 2:
                  <ul>
                    <li>Change your default language by going to Settings (<mat-icon
                        style="color: #777; display: inline-flex; vertical-align: middle;">settings</mat-icon>) and
                      selecting your choice under <i>My Details > Default Language</i> </li>
                  </ul>
                  <br />
                  <h3>APP </h3>
                  <h4>1. Include additional product information </h4>
                  After selecting a chemical, users now have the option to add the following information directly
                  through the phone:
                  <ul>
                    <li>Batch/Lot Number </li>
                    <li>Purchase Date </li>
                    <li>Expiry Date</li>
                  </ul>
                  <br />
                  If you have any questions, feel free to contact our team via <a
                    href="mailto:members@thebhive.net">members@thebhive.net</a>. <br />
                  <br />
                  Warm regards, <br />
                  Your The BHive-Team <br />
                  <br />
                  <br />
                  <h3>Haven’t had the chance to catch up? </h3>
                  <h3>See the previous updates here: </h3>
                  <br />
                  <h4>1. Enter your HIGG and Supplier ID</h4>
                  You can now include your HIGG ID as well as individual supplier IDs for different customers to your
                  profile. <br />
                  Both can be found in your profile settings (<mat-icon
                    style="color: #777; display: inline-flex; vertical-align: middle;">settings</mat-icon>). <br />
                  Enter your individual supplier ID for each of your customers in the list of connected brands. <br />
                  Your HIGG ID can be entered below. <br />
                  <br />
                  <h3>2. Confirm completeness of your monthly inventories. </h3>
                  How does this work? <br />
                  Once you have scanned all chemical products used in one month, you can open the month’s summary and
                  set the button under “confirm completeness” to complete. <br />
                  <br />
                  Your connected brands and partners will then be able to see a green button as an indicator for
                  completeness of the month. <br />
                  <br />
                  <h3>3. Changes in the navigation: </h3>
                  All tools and features of The BHive are now found in a compromised navigation header, which you can
                  find above in the upper left corner. <br />
                  Simply click on the navigation symbol (<mat-icon
                    style="color: #777; display: inline-flex; vertical-align: middle;">menu</mat-icon>) to view all
                  tools and features. <br />
                  In our new section “Analytics” you will soon find reporting tools, with which you can track your
                  chemical performance. <br />
                  <br />
                  The BHive’s frontpage (former Dashboard) will now be found behind the new Home Button (<mat-icon
                    style="color: #777; display: inline-flex; vertical-align: middle;">home</mat-icon>).
                </div>
                <div *ngIf="isBrand || isImporter">
                  Dear The BHive-Brand Members <br />
                  <br />
                  In this section we will inform you about <u><b>What is New</b></u> in The BHive: <br />
                  <br />
                  <h3>Desktop Platform</h3>
                  <h4>1. The BHive Dashboard Statistics</h4>
                  With the new Dashboard feature you can now see important numbers and developments in one view. <br />
                  <br />
                  <br />
                  <h4>2. New Language Features</h4>
                  Users can now use The BHive in three languages: <br />
                  <ul>
                    <li>Chinese</li>
                    <li>English</li>
                    <li>Spanish</li>
                  </ul>
                  <i>Soon to follow: Turkish and Vietnamese</i> <br />
                  <br />
                  <u>How to change your language:</u> <br />
                  Option 1: <br />
                  <ul>
                    <li>Change the language immediately by clicking on the field next to the Settings (upper right
                      corner) </li>
                  </ul>

                  Option 2: <br />
                  <ul>
                    <li>Change your default language by going to Settings (<mat-icon
                        style="color: #777; display: inline-flex; vertical-align: middle;">settings</mat-icon>) and
                      selecting your choice under <i>My Details > Default Language</i> </li>
                  </ul>

                  <h3>APP </h3>
                  <h4>1. Include additional product information </h4>
                  After selecting a chemical, App users now have the option to add the following information directly
                  through the phone: <br />
                  <ul>
                    <li>Batch/Lot Number </li>
                    <li>Purchase Date </li>
                    <li>Expiry Date</li>
                  </ul>

                  For more information feel free to contact us via <a
                    href="mailto:members@thebhive.net">members@thebhive.net</a>. <br />
                  <br />
                  Warm regards, <br />
                  Your The BHive-Team <br />
                  <br />
                  <br />
                  <h3>Haven’t had the chance to catch up?</h3>
                  <h3>See the previous updates here: </h3>
                  <br />
                  <h4>1. See your facilities’ HIGG IDs and Supplier IDs</h4>
                  Your connected facilities now have the option to fill in the supplier ID specified to your brand, as
                  well as their HIGG ID in the settings. <br />
                  Where to find the IDs? <br />
                  <ul>
                    <li>Both supplier and HIGG ID can be found under “Wet Processing Units” in the Menu Bar. Please
                      select the facility whose profile you would like to view. </li>
                    <li>Additionally, the supplier ID will be shown under “Supplier Inventories” when selecting said
                      factory, under the factories Name </li>
                  </ul>
                  <br />
                  <i>Please note:</i> Factory must have entered the ID in order for you to see them.
                  <br />
                  <h4>2. Monthly completeness confirmation </h4>
                  Your connected facilities now have the option to mark a month’s inventory as complete. <br />
                  When selecting country, facility, year and period under “Supplier Inventories”, you can now see
                  whether a month is marked as complete or incomplete. <br />
                  <br />
                  <i>Please note:</i> In order to see a month’s completeness, you have to select a certain month
                  (quarterly and annual summaries are not included.)
                  <br />
                  <h4>3. The BHive compliance reporting. </h4>
                  You will find the tool in the updated navigation above (<mat-icon
                    style="color: #777; display: inline-flex; vertical-align: middle;">menu</mat-icon>) in the new
                  section <i>“Analytics”</i>. <br />
                  <br />
                  The new tool allows a customized filtering of your factories’ compliance performance either based on
                  country or transnationally. <br />
                  You are also able to select a time frame, as well as the compliance criteria that acts as base for the
                  performance evaluation. <br />
                  With this, you are now able to compare your different factories’ performance throughout the
                  globe.<br />
                  <br />
                  Our team will further expand Analytics in the next few months, e.g. by adding a comparison option
                  including different time frames, with which you will be able to track performance development. <br />
                  <br />
                  <h4>4. Filter by Customer option for brands: </h4>
                  When visiting the factories’ inventories, you are now able to filter the chemical product list for
                  chemicals that were marked as used for [your brand] by the factory user. <br />
                  <br />
                  Please note that you will only see the products that were actively marked as used for {{myName}} by
                  the factory.
                </div>
              </div>
            </div>
          </div>
          -->


          <!--

          <div class="col-md-6">
            <div class="panel panel-default" style="height: 400px;">
              <div class="panel-heading"
                i18n="Brand Information | The field on the dashboard containing brand information.">
                {{"HOME_COMPONENT.BRAND_INFO_BOX_HEADER" | translate}}</div>
              <div class="panel-body" style="height:338px;overflow-y:scroll;">
                <div *ngIf="showFashionInfos" class="panel-body">
                  <strong>Lidl:</strong>
                  <div>
                    Tools and Guidelines:
                    <ul>
                      <li><a href="/assets/Lidl/Chemical_Restrictions.pdf" target="_blank">Detox Chemical
                          Restrictions</a></li>
                      <li><a href="/assets/Lidl/Supplier_Guideline-Environmental_Management.pdf">Supplier Guideline -
                          Environmental Management</a></li>
                    </ul>
                  </div>
                </div>
                <div *ngIf="showFashionInfos" class="panel-body">
                  <strong>FashionBlu:</strong>
                  <div>
                    Here you can insert all brand related information that you would like to share with your suppliers
                    using the BHive. <br><br>

                    These can by any kind of written or (URL-)linked information, e.g. environmental requirements, such
                    as Brand MRSL, and notifications about their updates. <br><br>

                    The information will only be seen by suppliers that are connected to your account.

                  </div>
                </div>
                <div *ngIf="showWalmartInfos" class="panel-body">
                  <strong>FashionBlu:</strong>
                  <div>
                    Here you can insert all brand related information that you would like to share with your suppliers
                    using the BHive. <br><br>

                    These can by any kind of written or (URL-)linked information, e.g. environmental requirements, such
                    as Brand MRSL, and notifications about their updates. <br><br>

                    The information will only be seen by suppliers that are connected to your account.

                  </div>
                </div>
                <div *ngIf="showPumaInfos" class="panel-body">
                  <strong>PUMA:</strong>
                  <div>
                    Here you can insert all brand related information that you would like to share with your suppliers
                    using the BHive. <br><br>

                    These can by any kind of written or (URL-)linked information, e.g. environmental requirements, such
                    as Brand MRSL, and notifications about their updates. <br><br>

                    The information will only be seen by suppliers that are connected to your account.

                  </div>
                </div>
                <div *ngIf="showVFInfos" class="panel-body">
                  <strong>Dear VF-Supplier,</strong>
                  <div>
                    You will find all training material including the checklists to complete the Chem-IQ process under
                    the following links: <br><br>

                    Chem-IQ - The BHive - Training Material: <a href="https://cloud.goblu.net/s/itwgQwTjwYtHc5d"
                      target="_blank">CHINESE </a> <br>
                    Chem-IQ - The BHive - Training Material: <a href="https://cloud.goblu.net/s/538n8RxDC3WCcC8"
                      target="_blank">ENGLISH </a> <br>
                    Chem-IQ - The BHive - Training Material: <a href="https://cloud.goblu.net/s/aj4xWq5B8ms8ciw"
                      target="_blank">SPANISH </a> <br>

                    Please select the language that you need. <br><br>

                    If you have any questions, contact us via vf@thebhive.net. <br><br>

                    Warm regards, <br>
                    Your Chem-IQ- and BHive-Team

                  </div>
                </div>

                <div *ngIf="showOrsayInfos" class="panel-body">
                  <strong>Orsay:</strong>
                  <div>
                    Tools and Guidelines:
                    <ul>
                      <li><a href="/assets/Orsay/ANIMAL_WELFARE.pdf" target="_blank">Animal Welfare Policy</a></li>
                      <li><a href="/assets/Orsay/CHILD_LABOUR_&_YOUNG_WORKERS_POLICY.pdf" target="_blank">Child Labour &
                          Young Workers Policy</a></li>
                      <li><a href="/assets/Orsay/OUR_COMMITMENT_TO_PROTECT_FORESTS.pdf" target="_blank">Commitment to
                          Protect Forests Through Our Paper, Packaging and Fabrics Choices</a></li>
                      <li><a href="/assets/Orsay/INTRODUCTION_CORPORATE_RESPONSIBILITY_POLICIES_AND_TOOLS.pdf"
                          target="_blank">Corporate Responsibility Codes, Policies & Tools</a></li>
                      <li><a href="/assets/Orsay/ENVIRONMENTAL_AND_CHEMICAL_GUIDELINE.pdf" target="_blank">Environmental
                          And Chemical Guideline</a></li>
                      <li><a href="/assets/Orsay/FORCED_LABOUR_POLICY.pdf" target="_blank">Forced Labour Policy</a></li>
                      <li><a href="/assets/Orsay/SUPPLY_CHAIN_CODE_OF_CONDUCT.pdf" target="_blank">Supply Chain Code of
                          Conduct</a></li>
                      <li><a href="/assets/Orsay/ZDHC_MRSL_extended_V2.0.pdf" target="_blank">ZDHC MRSL V2.0</a></li>
                      <li><a href="/assets/Orsay/ZDHC_WastewaterGuidelines_V1.1_JUL19.pdf" target="_blank">ZDHC
                          Wastewater Guidelines Version 1.1</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          -->

          <!-- <div class="col-md-6">
            <div class="panel panel-default">
              <div class="panel-heading" i18n="FSWR | Dashboard information about Fashion Sustainability Week.">
                {{"HOME_COMPONENT.GOBLU_NEWS_BOX.HEADER" | translate}}</div>
              <div class="panel-body">
                <a class="twitter-timeline" data-height="300"
                  href="https://twitter.com/GoBlu_news?ref_src=twsrc%5Etfw">{{"HOME_COMPONENT.GOBLU_NEWS_BOX.TWEETS_HEADLINE"
                  | translate}}</a>
              </div>
            </div>
          </div> -->


          <!-- <div class="col-md-6">
            <div class="panel panel-default">
              <div class="panel-heading" i18n="BHive Chemical News | Dashboard header for field BHive Chemical News.">
                {{"HOME_COMPONENT.BHIVE_NEWS_BOX.HEADER" | translate}}</div>
              <div class="panel-body">
                <a class="twitter-timeline" data-height="300" href="https://twitter.com/BHiveGoBlu?ref_src=twsrc%5Etfw"
                  i18n="Tweets by BHive Chem News | Dashboard: Headline for Twitter field for BHive Chem News.">{{"HOME_COMPONENT.BHIVE_NEWS_BOX.TWEETS_HEADLINE"
                  | translate}}</a>
              </div>
            </div>
          </div> -->


          <!--
          // <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
          -->

        </div>
      </div>
    </div>
  </div>
</div>
